import type { DatoveSchrankyDatovaZpravaDto } from '@gov-nx/api/generated/datove-schranky.types';

export const isUnreadMessage = (message: DatoveSchrankyDatovaZpravaDto) =>
	message.statusDz !== '7' && message.statusDz !== null;
